import styled from 'styled-components';

export const Body = styled.div`
  display: flex;
  height: calc(100vh - 171px);
  width: 100%;
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
`;

export const Section = styled.div`
  overflow-y: scroll;
  padding: 14px 24px;
`;
